// extracted by mini-css-extract-plugin
module.exports = {"modalRegister":"formtoggler_modalRegister___UH6e","modalRegisterSpan":"formtoggler_modalRegisterSpan__fvhhe"};